import { isNil } from 'ramda';

import { IViolationEliminations } from 'APIPackage/KnmModule/interfaces/IKnmRequirementViolation';
import { IKnmErknmFormViolationFix } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { IViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IViolationMaterialTypeSelectOption';
import { convertKnmDocumentAttachmentFormValueToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentFormValueToKnmData';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export function convertViolationFixesFormValuesToKnmData(
  formViolationFixes: IKnmErknmFormViolationFix[],
  isDraft: boolean | undefined,
): IViolationEliminations[] {
  return formViolationFixes.map(fix => ({
    isNew: isDraft ? fix.isNew : null,
    guid: fix.id,
    materialType: fix.type?.length
      ? (fix.type.map(typeItem => typeItem.value).filter(item => !isNil(item)) as IViolationMaterialTypeSelectOption[])
      : null,
    actualMethod: fix.method,
    actualMethodFromMobile: fix.isMethodFromMobile,
    descriptionMaterial: fix.explanationMaterial,
    descriptionMaterialReactQuillEditor: handleReactQuillDeltaValue(
      fix.explanationMaterialReactQuillEditor || fix.explanationMaterial,
    ),
    grade: fix.grade?.value || null,
    descriptionGrade: fix.explanationGrade,
    attachments:
      fix.attachments?.map(attachmentItemData => ({
        ...attachmentItemData,
        attachment: attachmentItemData.attachment
          ? convertKnmDocumentAttachmentFormValueToKnmData(attachmentItemData.attachment)
          : null,
      })) || null,
  }));
}
